<template>
  <v-app id="inspire">
    <loading :active.sync="loader.loading" :loader="loader.type" :color="loader.color" :height="loader.size.height" :width="loader.size.width"/>
    <help-global-sidebar/>
    <v-content>
      <v-container fluid>
        <transition name="component-fade" mode="out-in">
          <router-view @loading="loading"/>
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import HelpGlobalSidebar from './shared/HelpGlobalSidebar';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Main',
  components: {
    Loading,
    HelpGlobalSidebar
  },
  data: () => ({
    loader: {
      loading: false,
      type: "dots",
      color: "#1C65FF",
      size: {
        height: 150,
        width: 200
      }
    }
  }),
  methods: { 
    loading (value) {
      this.loader.loading = value;
    }
  }
};
</script>